const currencyMap: Record<string, string> = {
    // North America
    US: "$",
    CA: "CAD $",
    MX: "MXN $",

    // Central & South America
    BR: "R$",    // Brazil
    AR: "ARS $", // Argentina
    CO: "COP $", // Colombia
    CL: "CLP $", // Chile
    PE: "S/",    // Peru
    UY: "$U",    // Uruguay
    VE: "Bs.",   // Venezuela
    BO: "Bs.",   // Bolivia
    PY: "₲",     // Paraguay
    EC: "$",     // Ecuador uses USD
    SV: "$",     // El Salvador uses USD
    PA: "B/.",   // Panama (Balboa/USD)
    CR: "₡",     // Costa Rica
    GT: "Q",     // Guatemala
    HN: "L",     // Honduras
    NI: "C$",    // Nicaragua
    DO: "RD$",   // Dominican Republic
    CU: "₱",     // Cuba
    JM: "J$",    // Jamaica
    TT: "TT$",   // Trinidad and Tobago
    BS: "B$",    // Bahamas
    BB: "Bds$",  // Barbados
    BZ: "BZ$",   // Belize
    HT: "G",     // Haiti
    GY: "G$",    // Guyana
    SR: "$",     // Suriname

    // Europe - Eurozone
    DE: "€", FR: "€", IT: "€", ES: "€", PT: "€", NL: "€", BE: "€",
    AT: "€", GR: "€", IE: "€", FI: "€", EE: "€", LV: "€", LT: "€",
    SK: "€", SI: "€", MT: "€", CY: "€", LU: "€", HR: "€", // Croatia joined Eurozone recently

    // Europe - Non-Euro
    GB: "£",     // United Kingdom
    CH: "CHF",   // Switzerland
    SE: "kr",    // Sweden
    NO: "kr",    // Norway
    DK: "kr",    // Denmark
    PL: "zł",    // Poland
    CZ: "Kč",    // Czech Republic
    HU: "Ft",    // Hungary
    RO: "lei",   // Romania
    BG: "лв",     // Bulgaria
    IS: "kr",    // Iceland
    RS: "дин",   // Serbia
    AL: "L",     // Albania
    MK: "ден",   // North Macedonia
    BA: "KM",    // Bosnia and Herzegovina
    MD: "L",     // Moldova
    UA: "₴",     // Ukraine

    // Selected others for context
    AU: "AUD $", // Australia
    NZ: "NZD $", // New Zealand
    IN: "₹",     // India
    ZA: "R",     // South Africa
    CN: "¥",     // China
    JP: "¥",     // Japan
    KR: "₩",     // South Korea
    SG: "SGD $", // Singapore

    // Middle East & Southeast Asia
    MY: "RM",    // Malaysia
    AE: "AED",   // United Arab Emirates (Dubai)
    QA: "QAR",   // Qatar
    SA: "SAR",   // Saudi Arabia
    KW: "KWD",   // Kuwait
    OM: "OMR",   // Oman
    BH: "BHD",   // Bahrain

    IQ: "IQD", // Iraq
    JO: "JOD", // Jordan
    LB: "£",   // Lebanon
    SY: "£",   // Syria
    TR: "₺",   // Turkey
    YE: "﷼",   // Yemen

    // Asia
    AF: "؋",  // Afghanistan
    AM: "֏",  // Armenia
    AZ: "₼",  // Azerbaijan
    BD: "৳",  // Bangladesh
    BT: "Nu.", // Bhutan
    KH: "៛",  // Cambodia
    GE: "₾",  // Georgia
    ID: "Rp", // Indonesia
    KZ: "₸",  // Kazakhstan
    LA: "₭",  // Laos
    MV: "Rf", // Maldives
    MN: "₮",  // Mongolia
    MM: "Ks", // Myanmar
    NP: "₨",  // Nepal
    PK: "₨",  // Pakistan
    PH: "₱",  // Philippines
    LK: "₨",  // Sri Lanka
    TH: "฿",  // Thailand
    TL: "$",  // Timor-Leste
    TM: "m",  // Turkmenistan
    UZ: "so'm", // Uzbekistan
    VN: "₫",  // Vietnam
    TW: "NT$", // Taiwan
};

const currencyCodeMap: Record<string, string> = {
    // North America
    US: "usd",
    CA: "cad",
    MX: "mxn",
  
    // Central & South America
    BR: "brl",
    AR: "ars",
    CO: "cop",
    CL: "clp",
    PE: "pen",
    UY: "uyu",
    VE: "ves",
    BO: "bob",
    PY: "pyg",
    EC: "usd",
    SV: "usd",
    PA: "usd",
    CR: "crc",
    GT: "gtq",
    HN: "hnl",
    NI: "nio",
    DO: "dop",
    CU: "cup",
    JM: "jmd",
    TT: "ttd",
    BS: "bsd",
    BB: "bbd",
    BZ: "bzd",
    HT: "htg",
    GY: "gyd",
    SR: "srd",
  
    // Eurozone
    DE: "eur", FR: "eur", IT: "eur", ES: "eur", PT: "eur", NL: "eur",
    BE: "eur", AT: "eur", GR: "eur", IE: "eur", FI: "eur", EE: "eur",
    LV: "eur", LT: "eur", SK: "eur", SI: "eur", MT: "eur", CY: "eur",
    LU: "eur", HR: "eur",
  
    // Europe Non-Euro
    GB: "gbp",
    CH: "chf",
    SE: "sek",
    NO: "nok",
    DK: "dkk",
    PL: "pln",
    CZ: "czk",
    HU: "huf",
    RO: "ron",
    BG: "bgn",
    IS: "isk",
    RS: "rsd",
    AL: "all",
    MK: "mkd",
    BA: "bam",
    MD: "mdl",
    UA: "uah",
  
    // Others
    AU: "aud",
    NZ: "nzd",
    IN: "inr",
    ZA: "zar",
    CN: "cny",
    JP: "jpy",
    KR: "krw",
    SG: "sgd",
  
    // Middle East
    MY: "myr",
    AE: "aed",
    QA: "qar",
    SA: "sar",
    KW: "kwd",
    OM: "omr",
    BH: "bhd",
    IQ: "iqd",
    JO: "jod",
    LB: "lbp",
    SY: "syp",
    TR: "try",
    YE: "yer",
  
    // Asia
    AF: "afn",
    AM: "amd",
    AZ: "azn",
    BD: "bdt",
    BT: "btn",
    KH: "khr",
    GE: "gel",
    ID: "idr",
    KZ: "kzt",
    LA: "lak",
    MV: "mvr",
    MN: "mnt",
    MM: "mmk",
    NP: "npr",
    PK: "pkr",
    PH: "php",
    LK: "lkr",
    TH: "thb",
    TL: "usd",
    TM: "tmt",
    UZ: "uzs",
    VN: "vnd",
    TW: "twd",
  };

export const getCurrencySymbol = (countryCode?: string): string => {
    if (!countryCode) return "$ ";
    const code = countryCode.toUpperCase();
    return (currencyMap[code] || "$") + " ";
};


export const getCurrencyCode = (countryCode?: string): string => {
    if (!countryCode) return "usd";
    const code = countryCode.toUpperCase();
    return currencyCodeMap[code] || "usd";
  };